export enum PaymentIssuerCode {
    EDENRED_BELGIUM_CADEAU = "edenred-belgium-cadeau",
    EDENRED_BELGIUM_ECO = "edenred-belgium-eco",
    MONIZZE_CADEAU = "monizze-cadeau",
    MONIZZE_ECO = "monizze-eco",
    SODEXO_CADEAUPASS = "sodexo-cadeaupass",
    SODEXO_ECOPASS = "sodexo-ecopass",
    MASTERCARD = "Mastercard",
    VISA = "Visa",
    KLARNA = "klarna",
    BANCONTACT = "bancontact"
}
